// src/App.js
import React from 'react';
import './App.css';
import logo from './logo.png';

//const FORM_URL = 'https://forms.cloud.microsoft/e/xiHqKdxXBn';

function App() {
  return (
    <div className="app">
      <header>
        <img src={logo} alt="TONUS Logo" />
        <h1>TONUS FP25 Application</h1>
      </header>

      <main className="container">
        <section>
          <h2>About the FP25 Fokusprojekt at ETH Zurich</h2>
          <p>
            The TONUS FP25 project is developing a continuous blood-pressure monitor that delivers real-time readings. By combining optical (PPG/ECG), ultrasonic and other sensors on a dedicated test rig, we aim to revolutionize biomarker measurement and maximize patient comfort. Invasive methods are complex and cuff-based measurements can be inaccurate (≈25 % error due to white-coat effect, …) and aren’t continuous – yet blood pressure remains one of our most vital health biomarkers (1.3 billion people live with hypertension). Learn more on our website: <a href="https://tonus.dev" target="_blank" rel="noopener noreferrer">tonus.dev</a>
          </p>
        </section>

        <section>
          <h2>Your Responsibilities</h2>
          <p><strong>Note:</strong> Responsibilities will depend on which sub-team you are working on.</p><br></br>

          <h3>Hardware &amp; Prototype Development</h3>
          <ul>
            <li>Select, integrate and validate PPG/ECG, ultrasound and additional sensors</li>
            <li>Design mechanical housings, sensor mounts and the silicone-molds in CAD</li>
            <li>Build and refine prototypes using 3D printing, CNC machining and assembly of the test rig</li>
          </ul>

          <h3>Signal Processing &amp; Algorithm Development</h3>
          <ul>
            <li>Implement and validate filtering, feature-extraction and blood-pressure estimation algorithms in Python and MATLAB</li>
            <li>Train and evaluate AI/ML models for continuous pressure prediction</li>
            <li>Optimize embedded firmware for real-time data acquisition and preprocessing</li>
          </ul>

          <h3>Modeling &amp; Simulation</h3>
          <ul>
            <li>Develop multiphysics models of sensor–tissue interaction and hemodynamics using MATLAB/Simulink, FEM/iFEM and CFD tools</li>
            <li>Run simulations under varied physiological conditions to guide hardware and algorithm design</li>
          </ul>

          <h3>Experimental Planning &amp; Validation</h3>
          <ul>
            <li>Plan and conduct benchtop and in-silico experiments on our artificial test rig</li>
            <li>Analyze measurement data, iterate on designs and benchmark performance against cuff and invasive standards</li>
          </ul>

          <h3>Documentation &amp; Collaboration</h3>
          <ul>
            <li>Maintain up-to-date technical reports, CAD/design files and test protocols</li>
            <li>Present findings at weekly team meetings and help coordinate milestone deliveries within the two-semester timeline</li>
          </ul>
        </section>

        <section>
          <h2>What You Bring</h2>
          <ul>
            <li>Enrollment in a BSc program at ETH Zürich (Mechanical, Electrical, Biomedical Engineering or closely related)</li>
            <li>Foundation in sensor technology, signal processing and CAD</li>
            <li>Hands-on rapid-prototyping experience (3D printing/CNC)</li>
            <li>Proficiency in Python and/or MATLAB for data analysis, modeling and algorithm development</li>
            <li>Meticulous attention to detail, a proactive problem-solving approach and excellent teamwork skills</li>
          </ul>
        </section>

        <section>
          <h2>Nice-to-Haves</h2>
          <ul>
            <li>Embedded-firmware development on microcontrollers</li>
            <li>Experience with machine-learning workflows (training, validation, deployment)</li>
            <li>Familiarity with CFD and FEM software</li>
            <li>Fluent German and/or English</li>
          </ul>
        </section>

        <section>
          <h2>What We Offer</h2>
          <ul>
            <li>Participation in an ETH Fokusprojekt (2 semesters, 20 ECTS)</li>
            <li>A multidisciplinary team of ten motivated students</li>
            <li>Hands-on experience with health-tech, AI/ML and multiphysics simulation</li>
            <li>Collaboration with leading partners in the medical and engineering industries</li>
            <li>Access to in-house test rigs (e.g. silicone arm)</li>
            <li>Flexible workspace on the ETH Zentrum Campus, IPZ and ECTS-credited work</li>
          </ul>
        </section>

        <section>
          <h2>Your Impact</h2>
          <p>
            You’ll help deliver a fully functional prototype—combining hardware, AI algorithms and simulation—that could reshape continuous blood-pressure monitoring and feed directly into future pilot studies and patent applications.
          </p>
        </section>

        <section className="apply-section">
          <p><strong>Note:</strong> Applications will be organized by your department (D-MAVT, D-ITET, D-HEST).</p>
          {/*<button className="btn apply-btn" onClick={() => window.location.href = FORM_URL}>
            Go to Application Form
          </button>
          <p className="fallback">
            If that doesn’t work, please email your application to <a href="mailto:apply@tonus.dev">apply@tonus.dev</a>.
          </p>*/}
        </section>
      </main>

      <footer>&copy; 2025 TONUS</footer>
    </div>
  );
}

export default App;
